import { FC } from 'react';
import VisaIcon from '@assets/images/partners/visa.png';
import useStyles from './styles';

const AmexIcon: FC = (props) => {
  const css = useStyles();

  return (
    <span className={css.container}>
      <img src={VisaIcon} {...props} />
    </span>
  );
};

export default AmexIcon;
